(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-looks-slider"] && !Shopify.designMode) return;
  try {
    
  const mvSwiper = new Swiper('.mv-swiper', {
    // Optional parameters
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,

    pagination: false,

    navigation: false,
    autoplay: {
      delay: 4000, // 4秒後に次のスライドへ
      disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
    },
    speed: 2000, // 2秒かけてフェード
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let swiper = null;

    function initializeSwiper() {
      const el = document.querySelector('.js-feature-collection-grid-content');
      if (!el) return;

      swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
      });
    }

    function destroySwiper() {
      if (swiper && typeof swiper.destroy === 'function') {
        // ← 型チェックを追加
        swiper.destroy();
        swiper = null; // ← undefined より null が明示的
      }
    }

    function handleResize() {
      const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (w < 840) {
        if (!swiper) {
          initializeSwiper();
        }
      } else {
        destroySwiper();
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-popularity"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.js-feature-collection-poularity');
    if (!el) return;

    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        type: 'progressbar',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-select"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let swiper = null;

    function initializeSwiper() {
      const el = document.querySelector('.js-feature-collection-menu-content');
      if (!el) return;

      swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
      });
    }

    function destroySwiper() {
      if (swiper && typeof swiper.destroy === 'function') {
        // ← 型チェックを追加
        swiper.destroy();
        swiper = null; // ← undefined より null が明示的
      }
    }

    function handleResize() {
      const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (w < 840) {
        if (!swiper) {
          initializeSwiper();
        }
      } else {
        destroySwiper();
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-pickup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let swiper = null;

    function initializeSwiper() {
      const el = document.querySelector('.js-featured-pickup-blog');
      if (!el) return;

      swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        // 前後の矢印
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

    function destroySwiper() {
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy();
        swiper = null;
      }
    }

    function handleResize() {
      const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (w < 840) {
        if (!swiper) {
          initializeSwiper();
        }
      } else {
        destroySwiper();
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.js-featured-reviews-flex');
    if (!el) return;

    const swiper = new Swiper(el, {
      slidesPerView: 1.5, // 少し次のスライドを見せる場合はここで調整
      spaceBetween: 40,
      centeredSlides: true,
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        840: {
          slidesPerView: 3,
          spaceBetween: 40,
          centeredSlides: false,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const heads = document.querySelectorAll('h2, h3, h4, h5, h6');
    if (heads && heads.length) {
      let contents = '';
      let prevLevel = 0;

      heads.forEach((head, i) => {
        const level = parseInt(head.localName.replace('h', ''));
        const className = `contents${level}`;

        head.innerHTML += `<a id="head${i}"></a>`;
        const item = `<li><a class="${className}" href="#head${i}">${head.textContent}</a></li>`;

        if (level > prevLevel) {
          contents += `<ol>${item}`;
        } else if (level < prevLevel) {
          contents += '</ol>'.repeat(prevLevel - level) + item;
        } else {
          contents += item;
        }

        prevLevel = level;
      });

      contents += '</ol>'.repeat(prevLevel - 2);

      const toc = document.querySelector('#table-of-content');
      toc.classList.add('toc'); 
      toc.innerHTML += `${contents}`;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
